export const formattValues = (values, key) => {
  const newValues = {}

  values.forEach((item, index) => {
    newValues[item[key]] = {
      ...item,
      indexOfList: index,
    }
  })

  return newValues
}
